"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGAnimationDropInFlipStaggered = exports.CTGAnimationDropInFlip = exports.CTGAnimationDropInStaggered = exports.CTGAnimationDropIn = exports.CTGAnimationFadeInFlipStaggered = exports.CTGAnimationFadeInFlip = exports.CTGAnimationFadeInStaggered = exports.CTGAnimationFadeIn = exports.CTGAnimationScaleInFlipStaggered = exports.CTGAnimationScaleInFlip = exports.CTGAnimationScaleInStaggered = exports.CTGAnimationScaleIn = exports.CTGIIntroCardByCardAnimation = exports.CTGIIntroAnimation = void 0;
const KHRandom_1 = require("../KH/KHRandom");
class CTGIIntroAnimation {
}
exports.CTGIIntroAnimation = CTGIIntroAnimation;
class CTGIIntroCardByCardAnimation extends CTGIIntroAnimation {
    constructor(randomize = false) {
        super();
        this.randomize = randomize;
    }
    animate_in(scene, cards, callback) {
        if (this.randomize) {
            let rand = new KHRandom_1.KHRandomGeneral();
            rand.shuffleArray(cards);
        }
        this._cards = cards.length;
        this._callbacks_received = 0;
        let sub_callback = !callback ? undefined : () => {
            this._callbacks_received++;
            if (this._callbacks_received == this._cards) {
                if (callback)
                    callback();
            }
        };
        for (let i = 0; i < cards.length; i++) {
            let card = cards[i];
            let x_idx = i % 4;
            let y_idx = Math.floor(i / 4);
            this.animate_in_card(scene, card, cards.length, i, x_idx, y_idx, sub_callback);
        }
    }
}
exports.CTGIIntroCardByCardAnimation = CTGIIntroCardByCardAnimation;
class CTGAnimationScaleIn extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.animate_in_scale(200, 0, callback);
    }
}
exports.CTGAnimationScaleIn = CTGAnimationScaleIn;
class CTGAnimationScaleInStaggered extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.animate_in_scale(200, Math.min(idx * 800 / total, 50 * idx), callback);
    }
}
exports.CTGAnimationScaleInStaggered = CTGAnimationScaleInStaggered;
class CTGAnimationScaleInFlip extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.snap_card(false);
        card.animate_in_scale(200, 0, () => {
            card.maybe_flip_card(card.showing_front, 200, 0, callback);
        });
    }
}
exports.CTGAnimationScaleInFlip = CTGAnimationScaleInFlip;
class CTGAnimationScaleInFlipStaggered extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.snap_card(false);
        card.animate_in_scale(200, Math.min(idx * 800 / total, 50 * idx), () => {
            card.maybe_flip_card(card.showing_front, 200, Math.min(idx * 800 / total, 50 * idx), callback);
        });
    }
}
exports.CTGAnimationScaleInFlipStaggered = CTGAnimationScaleInFlipStaggered;
class CTGAnimationFadeIn extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.animate_in_fade(500, 0, callback);
    }
}
exports.CTGAnimationFadeIn = CTGAnimationFadeIn;
class CTGAnimationFadeInStaggered extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.animate_in_fade(500, Math.min(yIdx * 800 / (total / 4), yIdx * 200), callback);
    }
}
exports.CTGAnimationFadeInStaggered = CTGAnimationFadeInStaggered;
class CTGAnimationFadeInFlip extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.snap_card(false);
        card.animate_in_fade(500, 0, () => {
            card.maybe_flip_card(card.showing_front, 200, 0, callback);
        });
    }
}
exports.CTGAnimationFadeInFlip = CTGAnimationFadeInFlip;
class CTGAnimationFadeInFlipStaggered extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.snap_card(false);
        card.animate_in_fade(500, 0, () => {
            card.maybe_flip_card(card.showing_front, 200, Math.min(idx * 800 / total, 50 * idx), callback);
        });
    }
}
exports.CTGAnimationFadeInFlipStaggered = CTGAnimationFadeInFlipStaggered;
class CTGAnimationDropIn extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.animate_drop_in(500, 0, callback);
    }
}
exports.CTGAnimationDropIn = CTGAnimationDropIn;
class CTGAnimationDropInStaggered extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.animate_drop_in(500, Math.min(yIdx * 800 / (total / 4), yIdx * 200), callback);
    }
}
exports.CTGAnimationDropInStaggered = CTGAnimationDropInStaggered;
class CTGAnimationDropInFlip extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.snap_card(false);
        card.animate_drop_in(500, 0, () => {
            card.maybe_flip_card(card.showing_front, 200, 0, callback);
        });
    }
}
exports.CTGAnimationDropInFlip = CTGAnimationDropInFlip;
class CTGAnimationDropInFlipStaggered extends CTGIIntroCardByCardAnimation {
    animate_in_card(scene, card, total, idx, xIdx, yIdx, callback) {
        card.snap_card(false);
        card.animate_drop_in(500, 0, () => {
            card.maybe_flip_card(card.showing_front, 200, Math.min(idx * 800 / total, 50 * idx), callback);
        });
    }
}
exports.CTGAnimationDropInFlipStaggered = CTGAnimationDropInFlipStaggered;
